module.exports = __webpack_public_path__ + "img/earth.cdf49162.png";